import { render, staticRenderFns } from "./event-details.vue?vue&type=template&id=fbde7f12&scoped=true&"
import script from "./event-details.vue?vue&type=script&lang=js&"
export * from "./event-details.vue?vue&type=script&lang=js&"
import style0 from "./event-details.vue?vue&type=style&index=0&id=fbde7f12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbde7f12",
  null
  
)

export default component.exports